// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile .grouped-input {
  background-color: transparent;
  border: 1px solid #2d7ceb;
  border-radius: 4px;
  padding: 2px 8px;
}

.profile .disabled-input {
  background-color: #eeeeee;
  border: none;
}

.profile .grouped-input label {
  font-size: 10px;
  color: #a0a0a0;
}

.profile .grouped-input input,
.profile .grouped-input select {
  background-color: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
}

.profile .add-agent {
  display: flex;
  gap: 10px;
  border-right: 1px solid #afafaf;
  padding: 40px 80px 40px 0px;
}

.profile .btn-add-agent {
  background-color: #3483f4;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  color: #ffffff;
}

.profile .alert {
  color: #842f03;
  margin-top: 50px;
  padding: 0;
  margin-bottom: 0;
}

.profile .fa-circle-exclamation {
  font-size: 16px;
  padding-right: 8px;
}

.profile small {
  margin-left: 24px;
}

.profile .section-heading {
  display: flex;
  border-bottom: 2px solid #eeeeee;
  padding: 20px;
}

.profile section {
  margin-top: 10px;
}

.profile .form small {
  color: #e86880;
}

.profile .edit-btn {
  margin-left: auto;
  background-color: #ffffff;
  border: 1px solid #cecece;
  border-radius: 8px;
}

.edit-action {
  margin-left: auto;
}

.profile .cancel-btn {
  margin-left: auto;
  background-color: #ffffff;
  border: 1px solid #cecece;
  border-radius: 8px;
  padding: 5px;
}

.profile .save-btn {
  margin-left: auto;
  background-color: #2d7ceb;
  border: 1px solid #cecece;
  color: #ffffff;
  border: 1px solid #2d7ceb;
  border-radius: 8px;
  padding: 5px;
  padding-inline: 10px;
  margin-left: 15px;
}

.profile .fa-pen-to-square {
  padding: 0;
}

.copy-invite {
  position: relative;
  display: flex;
  border: 1px solid #3383f3;
  border-radius: 4px;
  padding: 8px 12px;
}

.copy-invite .fa-copy {
  color: #3383f3;
  font-size: 16px;
}

.copy-invite .invite-btn {
  border: none;
  background-color: transparent;
  padding-inline: 10px 0px;
}

.copy-invite .link {
  width: 120px;
  height: 20px;
  overflow: auto; /* Enable scrolling */
  scrollbar-width: none; /* Hide the scrollbar for Firefox */
  -ms-overflow-style: none; /* Hide the scrollbar for Internet Explorer and Edge */
}

.copy-invite .link::-webkit-scrollbar {
  display: none; /* Hide the scrollbar for Chrome, Safari, and Opera */
}

.profile .add-agent-form .file-area {
  background-color: transparent;
  border: 1px dashed #3383f3;
  border-radius: 4px;
  padding: 8px 35px;
  margin-left: 80px;
  color: #777777;
  text-align: center;
  font-size: 12px;
}

.profile .file-area {
  background-color: #ffffff;
  font-size: 12px;
}

.profile .document-border .file-area {
  height: 250px;
}

.profile .document-border .file-area img {
  height: 100%;
}

.profile .upload-icon {
  height: 30px;
  width: 30px;
  margin: 5px;
}

.profile .file-name {
  width: 300px;
  margin-left: 20px;
  font-size: 12px;
}

.tooltip {
  position: absolute;
  bottom: -28px;
  right: -60px;
  transform: translateX(-50%);
  background-color: #000;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.tooltip::before {
  content: "";
  position: absolute;
  bottom: 30px;
  right: 40px;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #000 transparent;
}

.profile .disabled-doc {
  pointer-events: none;
  opacity: 0.5; /* Optionally, you can reduce the opacity to visually indicate it's disabled */
}
`, "",{"version":3,"sources":["webpack://./src/view/user-dashboard/Profile.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc,EAAE,qBAAqB;EACrC,qBAAqB,EAAE,mCAAmC;EAC1D,wBAAwB,EAAE,sDAAsD;AAClF;;AAEA;EACE,aAAa,EAAE,qDAAqD;AACtE;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,YAAY,EAAE,8EAA8E;AAC9F","sourcesContent":[".profile .grouped-input {\n  background-color: transparent;\n  border: 1px solid #2d7ceb;\n  border-radius: 4px;\n  padding: 2px 8px;\n}\n\n.profile .disabled-input {\n  background-color: #eeeeee;\n  border: none;\n}\n\n.profile .grouped-input label {\n  font-size: 10px;\n  color: #a0a0a0;\n}\n\n.profile .grouped-input input,\n.profile .grouped-input select {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  box-shadow: none;\n}\n\n.profile .add-agent {\n  display: flex;\n  gap: 10px;\n  border-right: 1px solid #afafaf;\n  padding: 40px 80px 40px 0px;\n}\n\n.profile .btn-add-agent {\n  background-color: #3483f4;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  color: #ffffff;\n}\n\n.profile .alert {\n  color: #842f03;\n  margin-top: 50px;\n  padding: 0;\n  margin-bottom: 0;\n}\n\n.profile .fa-circle-exclamation {\n  font-size: 16px;\n  padding-right: 8px;\n}\n\n.profile small {\n  margin-left: 24px;\n}\n\n.profile .section-heading {\n  display: flex;\n  border-bottom: 2px solid #eeeeee;\n  padding: 20px;\n}\n\n.profile section {\n  margin-top: 10px;\n}\n\n.profile .form small {\n  color: #e86880;\n}\n\n.profile .edit-btn {\n  margin-left: auto;\n  background-color: #ffffff;\n  border: 1px solid #cecece;\n  border-radius: 8px;\n}\n\n.edit-action {\n  margin-left: auto;\n}\n\n.profile .cancel-btn {\n  margin-left: auto;\n  background-color: #ffffff;\n  border: 1px solid #cecece;\n  border-radius: 8px;\n  padding: 5px;\n}\n\n.profile .save-btn {\n  margin-left: auto;\n  background-color: #2d7ceb;\n  border: 1px solid #cecece;\n  color: #ffffff;\n  border: 1px solid #2d7ceb;\n  border-radius: 8px;\n  padding: 5px;\n  padding-inline: 10px;\n  margin-left: 15px;\n}\n\n.profile .fa-pen-to-square {\n  padding: 0;\n}\n\n.copy-invite {\n  position: relative;\n  display: flex;\n  border: 1px solid #3383f3;\n  border-radius: 4px;\n  padding: 8px 12px;\n}\n\n.copy-invite .fa-copy {\n  color: #3383f3;\n  font-size: 16px;\n}\n\n.copy-invite .invite-btn {\n  border: none;\n  background-color: transparent;\n  padding-inline: 10px 0px;\n}\n\n.copy-invite .link {\n  width: 120px;\n  height: 20px;\n  overflow: auto; /* Enable scrolling */\n  scrollbar-width: none; /* Hide the scrollbar for Firefox */\n  -ms-overflow-style: none; /* Hide the scrollbar for Internet Explorer and Edge */\n}\n\n.copy-invite .link::-webkit-scrollbar {\n  display: none; /* Hide the scrollbar for Chrome, Safari, and Opera */\n}\n\n.profile .add-agent-form .file-area {\n  background-color: transparent;\n  border: 1px dashed #3383f3;\n  border-radius: 4px;\n  padding: 8px 35px;\n  margin-left: 80px;\n  color: #777777;\n  text-align: center;\n  font-size: 12px;\n}\n\n.profile .file-area {\n  background-color: #ffffff;\n  font-size: 12px;\n}\n\n.profile .document-border .file-area {\n  height: 250px;\n}\n\n.profile .document-border .file-area img {\n  height: 100%;\n}\n\n.profile .upload-icon {\n  height: 30px;\n  width: 30px;\n  margin: 5px;\n}\n\n.profile .file-name {\n  width: 300px;\n  margin-left: 20px;\n  font-size: 12px;\n}\n\n.tooltip {\n  position: absolute;\n  bottom: -28px;\n  right: -60px;\n  transform: translateX(-50%);\n  background-color: #000;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  opacity: 0.9;\n  transition: opacity 0.2s;\n}\n\n.tooltip::before {\n  content: \"\";\n  position: absolute;\n  bottom: 30px;\n  right: 40px;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent transparent #000 transparent;\n}\n\n.profile .disabled-doc {\n  pointer-events: none;\n  opacity: 0.5; /* Optionally, you can reduce the opacity to visually indicate it's disabled */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
